export default "__VITE_ASSET__CdUzcO_f__"